/* tslint:disable */
/* eslint-disable */
/**
 * Finastic Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckResetPasswordOtpCommand
 */
export interface CheckResetPasswordOtpCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckResetPasswordOtpCommand
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CheckResetPasswordOtpCommand
     */
    otp: string;
}

export function CheckResetPasswordOtpCommandFromJSON(json: any): CheckResetPasswordOtpCommand {
    return CheckResetPasswordOtpCommandFromJSONTyped(json, false);
}

export function CheckResetPasswordOtpCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckResetPasswordOtpCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phoneNumber': json['phoneNumber'],
        'otp': json['otp'],
    };
}

export function CheckResetPasswordOtpCommandToJSON(value?: CheckResetPasswordOtpCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phoneNumber': value.phoneNumber,
        'otp': value.otp,
    };
}

